import { useEffect, useRef, useState } from 'react';

export const useScrollVisibility = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollStartY, setScrollStartY] = useState(0);
  const ignoreScrollRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const lastHashRef = useRef(window.location.hash);

  let FIXED_THRESHOLD = 10;

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ignoreScrollRef.current) {
        scrollTimeoutRef.current = setTimeout(() => {
          ignoreScrollRef.current = false;
        }, 2500);
        return;
      }

      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const isMobile = window.innerWidth <= 1024;

          const documentHeight = document.documentElement.scrollHeight;
          const windowHeight = window.innerHeight;
          const scrollBottom = currentScrollY + windowHeight;
          const isNearBottom = documentHeight - scrollBottom < 50;

          if (isMobile && isNearBottom) {
            ticking = false;
            return;
          }

          if (Math.abs(currentScrollY - lastScrollY) < 3) {
            ticking = false;
            return;
          }

          if (currentScrollY > FIXED_THRESHOLD) {
            const isScrollingUp = currentScrollY < lastScrollY;
            const isScrollingDown = currentScrollY > lastScrollY;

            if (isMobile) {
              if (isScrollingUp) {
                if (lastScrollY >= scrollStartY || scrollStartY === 0) {
                  setScrollStartY(lastScrollY);
                }

                if (scrollStartY - currentScrollY >= 50) {
                  setIsVisible(true);
                }
              } else if (isScrollingDown) {
                setScrollStartY(currentScrollY);
                setIsVisible(false);
              }
            } else {
              // Desktop: Her zaman menüyü göster (hem yukarı hem aşağı scroll)
              setIsVisible(true);
            }
          } else {
            setIsVisible(false);
            setScrollStartY(currentScrollY);
          }

          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    const handleHashChange = () => {
      const currentHash = window.location.hash;

      if (currentHash !== lastHashRef.current) {
        lastHashRef.current = currentHash;
        setIsVisible(false);
        setScrollStartY(0);
        ignoreScrollRef.current = true;

        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [lastScrollY, scrollStartY]);

  return isVisible;
};
